import React from 'react'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'

const ItemStyle = styled.div`
  text-align: center;
  padding: 0 8px;
  margin: 16px 0;
`

const Icon = styled.img`
  height: 100px;
  @media (max-width: ${breakPoints.md.max}px) {
    height: 80px;
  }
`

const Title = styled.h4`
  font-weight: ${fontWeight.medium};
  font-size: 25px;
  margin-top: 16px;
  margin-bottom: 8px;
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 1.25rem;
  }
`

const Content = styled.p`
  font-size: 1rem;
  margin-bottom: 0;
`

const Item = ({ icon: { publicURL }, title, content }) => {
  return (
    <ItemStyle>
      <Icon src={publicURL} />
      <Title>{title}</Title>
      <Content>{content}</Content>
    </ItemStyle>
  )
}

export default Item
